import { VehicleAttributes } from '@own/fds-react/dist/types/vehicleSelector.types';
import { FMVehicleSelector } from '../../../common/fm-vehicle-selector/fm-vehicle-selector';
import { PageType } from '../../view-template/page-type';
import './onboarding-vehicle-selector.scss';
export const OnboardingVehicleSelector = ({
    vehicleYmmGroup,
    vin,
    onChange,
    page,
    disableDashboardRedirect,
}: {
    vin: string | undefined;
    vehicleYmmGroup: { year: number; make: string; model: string };
    onChange: (
        title: string,
        index: number,
        value: string,
        match: VehicleAttributes
    ) => void;
    disableDashboardRedirect: boolean;
    page: PageType;
}) => {
    return (
        <div className="onboarding-vehicle-selector">
            <FMVehicleSelector
                vehicleAttributes={{
                    year: vehicleYmmGroup!.year,
                    make: vehicleYmmGroup!.make,
                    model: vehicleYmmGroup!.model,
                    vin: vin,
                }}
                onChange={onChange}
                page={page}
                disableDashboardRedirect={disableDashboardRedirect}
            />
        </div>
    );
};
